// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"extract":true,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-rewriter.js?id=data-v-34592aaa&scoped=true!./~/less-loader?sourceMap!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/app-tags.vue
// module id = 1136
// module chunks = 129